module.exports = __webpack_public_path__ + "static/media/tag.f0442c85.svg";